<ng-container *transloco="let t">
@if (applicationTasks.length > 0) {
  <table class="table bp-table fixTableHead">
    <thead>
      <tr>
        <th width="30%">{{ t('portal.tasks.task') }}</th>
        <th width="20%">{{ t('portal.tasks.dueDateHeader') }}</th>
        <th width="10%">{{ t('portal.tasks.status') }}</th>
        <th width="30%">{{ t('portal.tasks.complete') }}</th>
        <th width="10%">{{ t('portal.tasks.actions') }}</th>
      </tr>
    </thead>
    <tbody>
      @for (task of applicationTasks; track task.taskId) {
        <tr class="bp-table-row">
          <td width="30%">
            <span class="fw-bold">{{ task | taskText:'docType' }}</span>
          </td>
          <td width="20%">
            <span class="fw-bold">{{ task.dueDate | dateAgo }}</span>
          </td>
          <td width="10%">
            <span class="fw-bold">{{ task.borrowerTaskStatus }}</span>
          </td>
          <td width="30%">
            <span class="fw-bold">{{ task | taskText:'description' }}</span>
          </td>
          <td width="10%">
            <div>
              @if (task.templateDocumentUrl) {
                <a
                  [title]="t('portal.tasks.viewTemplateDoc')"
                  class="align-text-bottom"
                  (click)="goToLink(task.templateDocumentUrl)"
                >
                  <i class="far fa-eye"></i>
                </a>
              }

              <a
                [title]="t('portal.tasks.addFiles')"
                class="mx-2 align-text-bottom"
                (click)="openAddFiles(task)"
              >
                <i class="fas fa-upload"></i>
              </a>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (applicationTasks.length === 0) {
  <h2 class="text-center my-4">
    {{ t('portal.tasks.noTaskFound') }}
  </h2>
}
</ng-container>
